export default "<div [ngClass]=\"el.config.class\">\n\t<img alt=\"{{el.text}}\" src=\"{{el.image_url}}\"  />\n</div>";